import { devtools } from "zustand/middleware";
import { createStore } from "zustand/vanilla";
import { ActionResult } from "./actionResult";
import { Appointment } from "./domain/appointment";
import { CalendarConfig } from "./domain/calendarConfig";
import { User } from "./domain/user";

type AuthState = { type: "signed-out" } | { type: "signed-in"; user: User } | { type: "error"; error: Error };

export interface AppState {
  authState: AuthState;
  actionResults: ActionResult<unknown>[];
  appointments: { [id: string]: Appointment[] | undefined };
  publicConfigs: CalendarConfig[] | undefined;
}

export const initStore = () => {
  const devtoolsImpl = import.meta.env.MODE === "development" ? devtools : (((x) => x) as typeof devtools);

  return createStore<AppState>()(
    devtoolsImpl(
      () =>
        ({
          authState: { type: "signed-out" },
          actionResults: [],
          appointments: {},
          publicConfigs: undefined,
        }) as AppState,
    ),
  );
};

export type AppStore = ReturnType<typeof initStore>;
